"use client"

import {SWRConfig, SWRConfiguration} from "swr";
import Cookies from "js-cookie";
import {apiPathName} from "./project-urls";
import React from "react";

export const fetcher = async <T = any>(url: string): Promise<T> => {
    try {
        const token = Cookies.get("token");
        const res = await fetch(`${apiPathName}${url}`, {
            headers: {
                ...(token ? {Authorization: `Bearer ${token}`} : {}),
            },
            credentials: "include",
        });

        if (!res.ok) throw new Error("Request failed");

        const result = await res.json();
        return result.data;
    } catch (err) {
        console.error("Fetcher error:", err);
        throw err;
    }
};

export const defaultSWRConfig: SWRConfiguration = {
    fetcher,
    revalidateOnReconnect: false,
    revalidateOnFocus: false,
    revalidateOnMount: true,
    refreshInterval: 0,
    dedupingInterval: 30_000,
};

export const swrStaticConfig: SWRConfiguration = {
    fetcher,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateOnMount: true,
    refreshInterval: 0,
    dedupingInterval: 60 * 60 * 1000,
};

export const SwrConfig = ({
                              value,
                              children,
                          }: {
    value?: SWRConfiguration;
    children: React.ReactNode;
}) => {

    return (
        <SWRConfig value = {{...defaultSWRConfig, ...value}} >
            {children}
        </SWRConfig >
    );
};
